import Button from 'atoms/Button/Button';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { OfferingType } from 'stores/networkInterfaces';
import { IOfferingInfo } from 'utils/globalTypes';
import { useOrderActions } from 'utils/hooks/useOrderActions';

import s from './BrowsingItemActions.module.scss';

const BrowsingItemActions = ({ item, className }: { item: IOfferingInfo; className?: string }) => {
  const {
    buyActionLabel,
    sellActionLabel,
    buyAction,
    sellAction,
    buyEnabled,
    sellEnabled,
    offeringId,
    offeringType
  } = useOrderActions(item);

  if (!buyEnabled && !sellEnabled) {
    return null;
  }

  return (
    <div
      className={cn(s.BrowsingItemActions, className)}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {offeringId && sellEnabled && offeringType === OfferingType.secondary && (
        <Button
          variant="contained"
          color="secondary"
          onClick={sellAction}
          className={s.BrowsingItemActions__action}
        >
          {sellActionLabel}
        </Button>
      )}
      {offeringId && buyEnabled && (
        <Button variant="contained" onClick={buyAction} className={s.BrowsingItemActions__action}>
          {buyActionLabel}
        </Button>
      )}
    </div>
  );
};

export default observer(BrowsingItemActions);
